import React, { PropsWithChildren } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Heading } from '../Heading/Heading';

type ImageUploadHeadlineProps = {
  headlineHierarchy?: number;
};
export function ImageUploadHeadline({ children, headlineHierarchy = 3 }: PropsWithChildren<ImageUploadHeadlineProps>) {
  const { t } = useSonTranslation('ImageUpload');
  return (
    <Heading className="form__headline" hierarchy={headlineHierarchy}>
      {children || t('headline')}
    </Heading>
  );
}
